<template>
  <div v-if="isOpen" class="modal-container">
    <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>
    <div class="modal-content w-[550px] relative bg-white w-full max-w-md m-auto flex-col flex rounded-lg z-50">
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark">
          Are you sure you want to delete <span class="font-bold">{{ projectName }}</span>?
        </h2>
      </div>

      <form @submit.prevent="deleteProject" class="overflow-y-auto px-6">
        <div class="mb-4">
          <p class="text-sm text-gray-600 mb-4">
            This action cannot be undone. This will permanently delete the project and all associated data.
          </p>
          <label class="block text-sm font-medium text-gray-700">
            To confirm, type "delete" in the box below
          </label>
          <input
            type="text"
            v-model="confirmationText"
            placeholder="Type delete"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <div class="flex justify-end gap-4 mb-4">
          <button 
            type="button" 
            class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" 
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            :class="[
              'py-2 px-4 w-[146px] h-[42px] text-white rounded',
              confirmationText === 'delete' ? 'bg-red-500 hover:bg-red-600' : 'bg-gray-300 cursor-not-allowed'
            ]"
            :disabled="confirmationText !== 'delete'"
          >
            Delete project
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteProjectModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: [String, Number],
      required: true,
    },
    projectName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmationText: "",
    };
  },
  methods: {
    deleteProject() {
      if (this.confirmationText === 'delete') {
        this.$emit('confirm-delete', this.projectId);
        this.confirmationText = '';
      }
    },
  },
  watch: {
    isOpen(newVal) {
      if (!newVal) {
        this.confirmationText = '';
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  z-index: 70;
}
</style>
